//
//
//
//
//
//
//
//

export default {
	name: 'email',
}
